import { Box, Button, Divider, Typography } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import Delete from '@mui/icons-material/Delete';

const LessonHeader = ({ isEdit, activeSectionName, onDeleteClick, theme }) => (
    <>
        <Box
            sx={{
                p: 3,
                backgroundColor: theme.palette.primary.main,
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2
            }}
        >
            <Box display="flex" alignItems="center" gap={2}>
                <PlayCircleOutlineIcon
                    sx={{
                        fontSize: '2.2rem',
                        color: theme.palette.secondary.main
                    }}
                />
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
                        {isEdit ? 'Edit Lesson' : 'Create New Lesson'}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.85 }}>
                        Adding content under manual:{' '}
                        <strong>
                            {activeSectionName || 'Selected Section'}
                        </strong>
                    </Typography>
                </Box>
            </Box>
            {isEdit && (
                <Button
                    variant="outlined"
                    color="error"
                    onClick={onDeleteClick}
                    sx={{
                        borderColor: theme.palette.error.light,
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: 'rgba(202, 0, 0, 0.15)',
                            borderColor: theme.palette.error.main
                        }
                    }}
                    startIcon={<Delete />}
                >
                    Delete
                </Button>
            )}
        </Box>
        <Divider />
    </>
);

export default LessonHeader;
